import * as React from 'react';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import * as ReqType from '../../../types/ServerRequests';
import { LigneEvent } from './LigneEvent';
import { EventService } from '../../../services/EventService';

export interface Props {
    date: Date;
}

interface State {
    listEvent: ReqType.Event [];
}

/**
 * Ce composant permet une liste d'event
 */
export class ListeEvent extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            listEvent: [],
        };
        EventService.getInstance().getEvents().then(
            (resp: ReqType.Event[]) => {
                this.setState({listEvent: resp});
            }
        ).catch(
            () => alert('Le service marche pas')
        );

    }

    render() {
        // alert(' ' + this.state.listUser.length + ' ');
        const listItems = this.state.listEvent.map(
            (event: ReqType.Event) => {
                    // alert(event.date_heure_debut.toLocaleDateString());
                    if (event.date_heure_debut.toLocaleDateString() === this.props.date.toLocaleDateString()) {
                    return (
                        <LigneEvent
                            event={event}
                            key={event.id}
                        />
                    );
                    } else {
                        return (<div/>);
                     }
            }
        );

        return (
            <div style={{marginBottom: '20px'}}>
                <TableChorinitia
                    header={
                        <thead className="thead-light">
                            <tr>
                                <th scope="col">Intitulé</th>
                                <th scope="col">Heure Debut</th>
                                <th scope="col">Heure Fin</th>
                                <th scope="col">Description</th>
                                <th scope="col">Voir l'Evènement</th>
                            </tr>
                        </thead>
                    }
                >
                    <tbody>
                    {listItems}
                    </tbody>
                </TableChorinitia>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SchedulePage/internalComponents/ListeEvent.tsx